import { adminAPIService } from './index'

const route = 'notifications'

export default {
  getList: ({ page = 1, size = 50 }) => {
    const params = { page, size }

    return adminAPIService({
      url: route,
      method: 'get',
      params,
    })
  },
  // getDetail: ({ id }) => adminAPIService({
  //   url: `${route}/${id}`,
  //   method: 'get',
  // }),
  create: (detail) => {
    const params = new URLSearchParams()
    params.append('target_id', detail.target_id)
    params.append('topic', detail.topic)
    params.append('message', detail.message)
    params.append('message_zh_hk', detail.message_zh_hk)
    params.append('is_test', detail.is_test)
    params.append('utm_params', detail.utm_params)
    if (detail.scheduled_at) {
      params.append('scheduled_at', detail.scheduled_at)
    }

    return adminAPIService({
      url: route,
      method: 'post',
      data: params.toString(),
    })
  },
  delete: ({ id }) => adminAPIService({
    url: `${route}/${id}`,
    method: 'delete',
  }),
}
